/**
 * Inject GymStack styles into Section Store Cart 2 shadow roots.
 */
(function () {
  const script = document.getElementById('gs-cart2-js');
  const cssUrl = script && script.dataset.css;
  let cssText = '';
  const waiting = [];

  function inject(el) {
    if (!el || el.tagName !== 'SECTION-STORE--CART-BLOCK') return;
    const tryOnce = function () {
      const root = el.shadowRoot;
      if (!root || !cssText) return false;
      if (root.getElementById('gs-cart2-theme')) return true;
      const style = document.createElement('style');
      style.id = 'gs-cart2-theme';
      style.textContent = cssText;
      root.appendChild(style);
      return true;
    };
    if (tryOnce()) return;
    waiting.push(el);
    const obs = new MutationObserver(function () {
      if (tryOnce()) obs.disconnect();
    });
    obs.observe(el, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
    }, 8000);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName === 'SECTION-STORE--CART-BLOCK') inject(root);
    root.querySelectorAll('section-store--cart-block').forEach(inject);
  }

  function flushWaiting() {
    waiting.splice(0).forEach(inject);
    scan(document);
  }

  if (cssUrl) {
    fetch(cssUrl)
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        cssText = text;
        flushWaiting();
      })
      .catch(function () {});
  }

  scan(document);
  if (!document.querySelector('section-store--cart-block')) {
    var rootObs = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
      if (document.querySelector('section-store--cart-block')) {
        rootObs.disconnect();
      }
    });
    rootObs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      rootObs.disconnect();
    }, 8000);
  }
})();
